var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialNetworkGithub18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1.5A7.5 7.5 0 001.5 9c0 3.315 2.152 6.127 5.13 7.125.375.06.495-.172.495-.375v-1.268c-2.077.45-2.52-1.005-2.52-1.005-.345-.87-.833-1.102-.833-1.102-.682-.465.053-.45.053-.45.75.052 1.147.772 1.147.772.653 1.14 1.755.803 2.183.623.067-.488.263-.818.473-1.005-1.665-.188-3.413-.832-3.413-3.69 0-.832.285-1.5.772-2.032-.075-.188-.337-.968.075-1.98 0 0 .63-.203 2.063.764A7.067 7.067 0 019 5.13c.637 0 1.283.083 1.875.248 1.432-.968 2.063-.766 2.063-.766.412 1.013.15 1.793.074 1.98.488.533.773 1.2.773 2.033 0 2.865-1.755 3.495-3.428 3.682.27.233.518.69.518 1.388v2.055c0 .203.12.442.502.375C14.355 15.12 16.5 12.315 16.5 9A7.5 7.5 0 009 1.5z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetworkGithub18);
export default __webpack_public_path__ + "131520a1438de74d33b5afb04503df28.svg";
export { ForwardRef as ReactComponent };